<template>
  <v-card outlined elevation="2" @click="showMore=!showMore">
    <v-card-title class="subtitle-2">
      <template>
        <span class="pr-2">#{{ hazard.number }}</span>
        <span>{{ hazard.classification }}</span>
      </template>
    </v-card-title>
    <v-card-subtitle>
      <span>Total Premium: {{ totalPremium }}</span>
    </v-card-subtitle>
    <v-card-text v-if="showMore" class="pt-0">
      <v-row wrap>
        <!-- <v-col class="py-0" cols="6">
          <DisplayField label="Class Code" :value="hazard.classCode" />
        </v-col> -->
        <v-col class="py-0" cols="6">
          <DisplayField label="Basis" :value="hazard.premiumBasis" />
        </v-col>
        <v-col class="py-0" cols="6">
          <DisplayField label="Exposure" :value="hazard.exposure" type="number" />
        </v-col>
        <v-col class="py-0" cols="6">
          <DisplayField label="Prem/Opts" :value="hazard.premisesRate" />
        </v-col>
        <v-col class="py-0" cols="6">
          <DisplayField label="Rate" :value="hazard.productsRate" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>
</style>

<script>
import DisplayField from '@/components/Shared/DisplayField.vue';
import displayFormatterService from '@/services/shared/displayFormatterService.js';

export default {
  name: 'HazardCard',
  components: { DisplayField },
  props: {
    hazard: {
      type: Object,
      default: null
    },
    location: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      showMore: false
    };
  },
  computed: {
    totalPremium: function () {
      if ((this.hazard || null) === null) return displayFormatterService.formatCurrency(0);
      return displayFormatterService.formatCurrency(this.hazard.totalPremium);
    }
  }
};
</script>
